module.exports = __webpack_public_path__ + "img/antes_despues_20.34f5071b.png";